import RideDetail from './RideDetail.jsx';
import './RideDetail.css';

export default RideDetail;
